import React, { memo, forwardRef } from "react";
const SvgInverse = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        stroke="#717171"
        strokeWidth={0.2}
        d="M18.277 9.042h0l.007.003a.92.92 0 00.379.067h1.673a.92.92 0 00.379-.067h0l.006-.003a.705.705 0 00.227-.188.545.545 0 00.125-.238.93.93 0 00.026-.196.93.93 0 00-.026-.197.545.545 0 00-.125-.238.597.597 0 00-.23-.178.805.805 0 00-.382-.08h-1.673a.805.805 0 00-.382.08.705.705 0 00-.24.175h0l-.005.006a.614.614 0 00-.11.235.93.93 0 00-.026.197c0 .056.01.122.026.196a.613.613 0 00.11.235h0l.005.006a.853.853 0 00.236.185zM23.483 5.8l1.022-.841v5.646c0 .171.025.321.078.446h0l.004.008a.82.82 0 00.213.264h0l.004.003c.085.06.174.1.266.12a.924.924 0 00.233.037c.066 0 .14-.013.22-.037a.626.626 0 00.27-.122.664.664 0 00.216-.27c.062-.125.091-.277.091-.45V3.876c0-.21-.032-.388-.102-.53a.762.762 0 00-.239-.316.673.673 0 00-.32-.147 1.116 1.116 0 00-.264-.037.953.953 0 00-.35.076c-.122.045-.26.13-.41.248h0l-1.813 1.465h0a.987.987 0 00-.284.337.696.696 0 00-.08.31.698.698 0 00.705.716.956.956 0 00.247-.038h0l.008-.002c.096-.035.189-.086.28-.153h0l.005-.004z"
      />
      <rect width={10} height={14} x={9} y={11.472} fill="#DBDBDB" rx={2} />
    </svg>
  );
});
SvgInverse.displayName = "SvgInverse";
const MemoForwardRef = memo(SvgInverse);
export default MemoForwardRef;
